
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/join",
      function () {
        return require("private-next-pages/home/join.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/join"])
      });
    }
  